import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import store from './store/'
import routes from './router/router'
// import headerApis from './service/apis/header.js'
import './plugins/element.js'
import * as Sentry from '@sentry/browser'
import { initSign } from '@didi/wsgsig'

// import Omega from 'Omega'

Vue.config.productionTip = false

const router = new Router({
  mode: 'history',
  base: '/',
  routes: routes
})

Vue.use(Router)

// var config = {
//   appKey: 'omega19ffd47eb9'
// }
// var Omega = Omega || config

// 埋点
Vue.prototype.omgTrack = function (eventId, eventName, param) {
  // console.log('9999')
  const { userInfo, selfGroup } = store.state.header
  let consParams = {
    company_id: userInfo ? userInfo.company_id : null,
    // phone: userInfo ? userInfo.phone : null,
    pid: userInfo ? userInfo.userId : null,
    group_id: selfGroup ? selfGroup.groupId : null
  }
  let data = Object.assign({}, consParams, param || {})

  Omega && Omega.trackEvent(eventId, eventName, data)
  // console.log('88888ddd' + store.state.header.selfGroup.groupId)
}
initSign({
  bizId: 'bc2d8b14812637aa6575dd2c3cae5323',
  appVer: '0.0.1', // 业务方自定义，方便问题排查时定位版本tag
  os: '4',  // 一定要传对，否则将被拦截
});
Sentry.init({
  dsn: 'https://46e9bf30ad6247cb96721d2f20982871@sentry.xiaojukeji.com/33',
  integrations: [new Sentry.Integrations.Vue({ Vue })],
  integrations: [new Sentry.Integrations.GlobalHandlers({ onunhandledrejection: false })],// 禁止自动上传错误  手动上报：Sentry.captureException(err)
  ignoreErrors: ['Omega.trackEvent is not a function', 'e.initMessageEvent is not a function', '_this.omgTrack is not a function']
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
